// components/CustomSelect.tsx

import React from "react";

const CustomSelect = ({
  value,
  onChange,
  options,
  className = "",
  placeholder,
  selectClassName = "",
}) => {
  return (
    <div className={`relative w-full sm:w-48 ${className}`}>
      <select
        className={`block w-full  pl-3 pr-10 text-sm font-medium bg-white border border-gray-300  outline-none appearance-none text-gray-700 ${
          selectClassName || "py-3 rounded-lg"
        }`}
        value={value}
        onChange={onChange}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options?.map((option) => (
          <option key={option?.value} value={option?.value}>
            {option?.label}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
        <svg
          className="w-5 h-5 text-gray-400"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>
  );
};

export default CustomSelect;
